import { OrgBaseInterface } from "../Shared/OrgBase.Interace";
import { PaymentSessionLeaseInterface } from "./PaymentSessionLease.Interface";

export enum PaymentSupportedCardBrand {
  VISA = "visa",
  MASTERCARD = "mastercard",
  AMEX = "amex",
  DISCOVER = "discover",
  DINERS_CLUB = "diners_club",
  JCB = "jcb"
}

export enum PaymentSessionStatus {
  CREATED = "created",
  OPENED = "opened",
  FAILED = "failed",
  IN_PROGRESS = "in_progress",
  COMPLETED = "completed",
  CANCELLED = "cancelled",
  EXPIRED = "expired"
}

export enum PaymentSessionMode {
  LIVE = "live",
  TEST = "test"
}

export interface PaymentSessionInterface extends OrgBaseInterface {
  sessionId: string;
  flowId: string;
  nonceHash: string;
  status: PaymentSessionStatus;
  mode: PaymentSessionMode;
  expiresAt: Date;
  openedAt: Date | null;
  completedAt?: Date | null;
  userId: number;
  paymentLink?: string | null;
  providerResult?: Record<string, any> | null;
  error?: string | null;
  shortLink?: string | null;
  supportedCardBrands?: PaymentSupportedCardBrand[];
  paymentSessionLeases?: PaymentSessionLeaseInterface[];
  paymentRequestAt?: Date | null;
  paymentProcessingStartAt?: Date | null;
  paymentProcessingEndAt?: Date | null;
  channelsToken?: string;
  channelsUrl?: string;
  channelName?: string;
  channel?: string | null;
  source?: string | null;
}

export interface MakePaymentQueuedResponse {
  sessionId: string;
  status: PaymentSessionStatus;
  channelsToken: string;
  channelsUrl: string;
  channelName: string;
}

export interface GetPaymentLinkPayload {
  orgId: number;
  userId: number;
  expirationInMinutes?: number;
  mode?: PaymentSessionMode;
  channel?: string;
  source?: string;
}

export interface OpenPaymentSessionPayload {
  sessionId: string;
  token: string;
}

export interface GetPaymentSessionSummaryPayload {
  sessionId: string;
  token: string;
}
